export default "__VITE_PUBLIC_ASSET__0a7497b5__"